import asyncComponent from 'components/Router/AsyncComponent';
import reducer from 'pages/Person/reducer';

export default asyncComponent(
  () => import('pages/RolesAndPermissions/UserRoleEditPage/container'),
  reducer,
  'route_user_roles',
);
